import styled from 'styled-components';
import Button from "../../Button";
import Icon from "../../Icon/Icon";
var ButtonMicro = styled(Button).withConfig({
  displayName: "ButtonMicro",
  componentId: "sc-1rowly7-0"
})(["padding:4px;border-radius:6px;height:24px;width:24px;& ", "{transition:fill 0.3s ease-in-out;}"], Icon);
export default ButtonMicro;